import React from 'react';
import { makeStyles, Button } from '@material-ui/core';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import { useTranslation } from 'react-i18next';

import { useFilterContext } from './FilterProvider';

const ClearFiltersButton = () => {
  const { t } = useTranslation();

  const {
    statusFilters,
    developmentStatusFilters,
    categoryFilters,
    dateRange,
    resetFilters
  } = useFilterContext();

  const isDateFiltered = dateRange.from && dateRange.to;

  const useStyles = makeStyles({
    filterGroup: {
      display: 'flex',
      gridGap: 8
    }
  }, { name: 'ClearFitlerButton' });

  const classes = useStyles();

  return (
    <div className={ classes.filterGroup }>
      {(
        isDateFiltered ||
        statusFilters.length !== 0 ||
        developmentStatusFilters.length !== 0 ||
        categoryFilters.length !== 0
      ) && (
        <Button
          onClick={ resetFilters }
          endIcon={ <HighlightOffIcon/> }
        >
          {t('objective.filter.clear')}
        </Button>
      )}
    </div>
  );
};

export default ClearFiltersButton;